<template>
  <library-container v-if="variants.v1 === variant" class="tw-pb-24 tw-pt-48">
    <div>
      <library-title :text="title"></library-title>
      <div class="tw-mt-10 tw-flex tw-flex-col tw-gap-y-4 lg:tw-mt-20">
        <div
          v-for="(branch, index) in branches"
          :key="`branch-${index}`"
          class="tw-grid tw-grid-cols-12 tw-gap-y-12 lg:tw-gap-x-12 xl:tw-gap-x-24"
        >
          <div class="tw-col-span-12 lg:tw-col-span-6">
            <nuxt-img :src="branch.photo" class="lg:tw-h-[416px] lg:tw-w-[650px]"></nuxt-img>
          </div>

          <div
            class="tw-col-span-12 tw-grid tw-grid-cols-12 tw-gap-x-6 tw-gap-y-8 lg:tw-col-span-6 lg:tw-gap-x-8 2xl:tw-gap-x-14"
          >
            <div v-if="branch.title" class="tw-col-span-12">
              <library-title tag="h2" :text="branch.title" class="tw-mb-2 lg:tw-mb-6" />
            </div>
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-4 lg:tw-col-span-6">
              <div v-if="branch.address" class="tw-pb-6" style="border-bottom: 1px solid var(--default-border-color)">
                <library-title
                  tag="h6"
                  style="color: var(--nc-mini-title-color); text-transform: uppercase"
                  text="Address"
                ></library-title>
                <div style="width: 230px" class="tw-break-words">
                  <library-text :text="branch.address" class="tw-mt-2 tw-font-bold"> </library-text>
                </div>
              </div>
              <div
                v-if="branch.primary_phone"
                class="tw-flex tw-flex-col tw-pb-6"
                style="border-bottom: 1px solid var(--default-border-color)"
              >
                <library-title
                  tag="h6"
                  style="color: var(--nc-mini-title-color); text-transform: uppercase"
                  text="Phone"
                ></library-title>
                <a v-if="branch.primary_phone" :href="`tel:${branch.primary_phone}`" class="tw-mt-2 tw-font-bold">
                  {{ branch.primary_phone }}
                </a>
                <a v-if="branch.secondary_phone" :href="`tel:${branch.secondary_phone}`" class="tw-mt-2 tw-font-bold">
                  {{ branch.secondary_phone }}
                </a>
              </div>
              <div
                v-if="branch.primary_email"
                class="tw-flex tw-flex-col tw-pb-6"
                style="border-bottom: 1px solid var(--default-border-color)"
              >
                <library-title
                  tag="h6"
                  style="color: var(--nc-mini-title-color); text-transform: uppercase"
                  text="EMAIL"
                ></library-title>
                <a
                  v-if="branch.primary_email"
                  :href="`mailto:${branch.primary_email}`"
                  class="tw-mt-2 tw-break-words tw-font-bold"
                >
                  {{ branch.primary_email }}
                </a>
                <a
                  v-if="branch.secondary_email"
                  :href="`mailto:${branch.secondary_email}`"
                  class="tw-mt-2 tw-break-words tw-font-bold"
                >
                  {{ branch.secondary_email }}
                </a>
              </div>
              <div v-if="branch.primary_email" class="tw-flex tw-flex-col tw-pb-6">
                <library-title
                  v-if="branch.facebook || branch.twitter || branch.linkedin || branch.youtube"
                  tag="h6"
                  style="color: var(--nc-mini-title-color); text-transform: uppercase"
                  text="Socials"
                ></library-title>
                <div class="tw-mt-3 tw-flex tw-flex-row">
                  <a
                    v-if="branch.facebook"
                    :href="branch.facebook"
                    target="_blank"
                    class="tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.33329 8.99967H11L11.6666 6.33301H9.33329V4.99967C9.33329 4.31301 9.33329 3.66634 10.6666 3.66634H11.6666V1.42634C11.4493 1.39767 10.6286 1.33301 9.76196 1.33301C7.95196 1.33301 6.66663 2.43767 6.66663 4.46634V6.33301H4.66663V8.99967H6.66663V14.6663H9.33329V8.99967Z"
                        fill="#11273E"
                      />
                    </svg>
                  </a>
                  <a
                    v-if="branch.twitter"
                    :href="branch.twitter"
                    target="_blank"
                    class="tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.20004 1.33301H10.8C12.9334 1.33301 14.6667 3.06634 14.6667 5.19967V10.7997C14.6667 11.8252 14.2593 12.8087 13.5342 13.5338C12.809 14.259 11.8255 14.6663 10.8 14.6663H5.20004C3.06671 14.6663 1.33337 12.933 1.33337 10.7997V5.19967C1.33337 4.17417 1.74075 3.19067 2.46589 2.46553C3.19104 1.74039 4.17454 1.33301 5.20004 1.33301ZM5.06671 2.66634C4.43019 2.66634 3.81974 2.9192 3.36965 3.36928C2.91956 3.81937 2.66671 4.42982 2.66671 5.06634V10.933C2.66671 12.2597 3.74004 13.333 5.06671 13.333H10.9334C11.5699 13.333 12.1803 13.0802 12.6304 12.6301C13.0805 12.18 13.3334 11.5695 13.3334 10.933V5.06634C13.3334 3.73967 12.26 2.66634 10.9334 2.66634H5.06671ZM11.5 3.66634C11.7211 3.66634 11.933 3.75414 12.0893 3.91042C12.2456 4.0667 12.3334 4.27866 12.3334 4.49967C12.3334 4.72069 12.2456 4.93265 12.0893 5.08893C11.933 5.24521 11.7211 5.33301 11.5 5.33301C11.279 5.33301 11.0671 5.24521 10.9108 5.08893C10.7545 4.93265 10.6667 4.72069 10.6667 4.49967C10.6667 4.27866 10.7545 4.0667 10.9108 3.91042C11.0671 3.75414 11.279 3.66634 11.5 3.66634ZM8.00004 4.66634C8.8841 4.66634 9.73194 5.01753 10.3571 5.64265C10.9822 6.26777 11.3334 7.11562 11.3334 7.99967C11.3334 8.88373 10.9822 9.73158 10.3571 10.3567C9.73194 10.9818 8.8841 11.333 8.00004 11.333C7.11599 11.333 6.26814 10.9818 5.64302 10.3567C5.0179 9.73158 4.66671 8.88373 4.66671 7.99967C4.66671 7.11562 5.0179 6.26777 5.64302 5.64265C6.26814 5.01753 7.11599 4.66634 8.00004 4.66634ZM8.00004 5.99967C7.46961 5.99967 6.9609 6.21039 6.58583 6.58546C6.21075 6.96053 6.00004 7.46924 6.00004 7.99967C6.00004 8.53011 6.21075 9.03882 6.58583 9.41389C6.9609 9.78896 7.46961 9.99967 8.00004 9.99967C8.53047 9.99967 9.03918 9.78896 9.41425 9.41389C9.78933 9.03882 10 8.53011 10 7.99967C10 7.46924 9.78933 6.96053 9.41425 6.58546C9.03918 6.21039 8.53047 5.99967 8.00004 5.99967Z"
                        fill="#11273E"
                      />
                    </svg>
                  </a>

                  <a
                    v-if="branch.linkedin"
                    :href="branch.linkedin"
                    target="_blank"
                    class="tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.62663 3.33302C4.62645 3.68665 4.48581 4.02571 4.23563 4.27564C3.98546 4.52556 3.64625 4.66587 3.29263 4.66569C2.93901 4.66551 2.59994 4.52487 2.35001 4.27469C2.10009 4.02452 1.95978 3.68531 1.95996 3.33169C1.96014 2.97807 2.10078 2.639 2.35096 2.38908C2.60113 2.13915 2.94034 1.99885 3.29396 1.99902C3.64758 1.9992 3.98665 2.13985 4.23658 2.39002C4.4865 2.64019 4.6268 2.9794 4.62663 3.33302ZM4.66663 5.65302H1.99996V13.9997H4.66663V5.65302ZM8.87996 5.65302H6.22663V13.9997H8.85329V9.61969C8.85329 7.17969 12.0333 6.95302 12.0333 9.61969V13.9997H14.6666V8.71302C14.6666 4.59969 9.95996 4.75302 8.85329 6.77302L8.87996 5.65302Z"
                        fill="#11273E"
                      />
                    </svg>
                  </a>
                  <a
                    v-if="branch.youtube"
                    :href="branch.youtube"
                    target="_blank"
                    class="tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1287_50)">
                        <path
                          d="M8.00004 2.66699C8.57004 2.66699 9.15471 2.68166 9.72137 2.70566L10.3907 2.73766L11.0314 2.77566L11.6314 2.81633L12.1794 2.85899C12.7741 2.90451 13.3337 3.15829 13.7597 3.57569C14.1858 3.99308 14.451 4.54735 14.5087 5.14099L14.5354 5.42433L14.5854 6.03099C14.632 6.65966 14.6667 7.34499 14.6667 8.00033C14.6667 8.65566 14.632 9.34099 14.5854 9.96966L14.5354 10.5763C14.5267 10.6737 14.518 10.7677 14.5087 10.8597C14.451 11.4534 14.1857 12.0078 13.7595 12.4252C13.3333 12.8426 12.7735 13.0963 12.1787 13.1417L11.632 13.1837L11.032 13.225L10.3907 13.263L9.72137 13.295C9.14793 13.3199 8.57403 13.3328 8.00004 13.3337C7.42606 13.3328 6.85215 13.3199 6.27871 13.295L5.60937 13.263L4.96871 13.225L4.36871 13.1837L3.82071 13.1417C3.22601 13.0961 2.66641 12.8424 2.24036 12.425C1.8143 12.0076 1.54909 11.4533 1.49137 10.8597L1.46471 10.5763L1.41471 9.96966C1.36373 9.31442 1.3366 8.65754 1.33337 8.00033C1.33337 7.34499 1.36804 6.65966 1.41471 6.03099L1.46471 5.42433C1.47337 5.32699 1.48204 5.23299 1.49137 5.14099C1.54907 4.54746 1.81419 3.99327 2.2401 3.57589C2.66602 3.15851 3.22546 2.90466 3.82004 2.85899L4.36737 2.81633L4.96737 2.77566L5.60871 2.73766L6.27804 2.70566C6.85171 2.68075 7.42583 2.66786 8.00004 2.66699ZM8.00004 4.00033C7.45004 4.00033 6.88404 4.01499 6.33337 4.03766L5.68137 4.06899L5.05537 4.10566L4.46737 4.14566L3.92871 4.18766C3.64559 4.20775 3.37874 4.32742 3.17544 4.52548C2.97214 4.72353 2.84552 4.98717 2.81804 5.26966C2.74004 6.07566 2.66671 7.07899 2.66671 8.00033C2.66671 8.92166 2.74004 9.92499 2.81804 10.731C2.87471 11.3123 3.33604 11.7643 3.92871 11.813L4.46737 11.8543L5.05537 11.8943L5.68137 11.9317L6.33337 11.963C6.88404 11.9857 7.45004 12.0003 8.00004 12.0003C8.55004 12.0003 9.11604 11.9857 9.66671 11.963L10.3187 11.9317L10.9447 11.895L11.5327 11.855L12.0714 11.813C12.3545 11.7929 12.6213 11.6732 12.8246 11.4752C13.0279 11.2771 13.1546 11.0135 13.182 10.731C13.26 9.92499 13.3334 8.92166 13.3334 8.00033C13.3334 7.07899 13.26 6.07566 13.182 5.26966C13.1546 4.98717 13.0279 4.72353 12.8246 4.52548C12.6213 4.32742 12.3545 4.20775 12.0714 4.18766L11.5327 4.14633L10.9447 4.10633L10.3187 4.06899L9.66671 4.03766C9.11147 4.01377 8.55579 4.00132 8.00004 4.00033ZM6.66671 6.38366C6.66666 6.3185 6.68254 6.25432 6.71295 6.19669C6.74336 6.13907 6.78739 6.08975 6.84121 6.05302C6.89503 6.01628 6.957 5.99325 7.02175 5.98593C7.08649 5.97861 7.15204 5.98721 7.21271 6.01099L7.26671 6.03766L10.0667 7.65366C10.1225 7.68583 10.1696 7.73098 10.2042 7.78528C10.2388 7.83958 10.2597 7.90143 10.2653 7.96556C10.2709 8.02969 10.2609 8.09422 10.2362 8.15366C10.2114 8.2131 10.1728 8.2657 10.1234 8.30699L10.0667 8.34699L7.26671 9.96366C7.21028 9.99633 7.14672 10.0147 7.08157 10.0172C7.01642 10.0197 6.95164 10.0062 6.89288 9.97798C6.83412 9.94972 6.78316 9.90752 6.74444 9.85506C6.70571 9.8026 6.6804 9.74147 6.67071 9.67699L6.66671 9.61699V6.38366Z"
                          fill="#11273E"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1287_50">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-4 lg:tw-col-span-6">
              <library-title
                tag="h6"
                style="color: var(--nc-mini-title-color); text-transform: uppercase"
                text="Opening Hours"
              ></library-title>
              <div
                v-for="(officeHour, officeHourIndex) in branch.office_hours"
                :key="`${officeHour.title}-${index}-${officeHourIndex}`"
                class="tw-flex tw-flex-row tw-justify-between"
              >
                <div>{{ officeHour.title }}</div>
                <div>
                  {{ officeHour.value }}
                </div>
              </div>
              <div v-if="branch.general_office_hour" class="tw-mt-4">
                {{ branch.general_office_hour }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </library-container>

  <library-container v-if="variants.v2 === variant" class="tw-pb-24 tw-pt-48">
    <div>
      <h2>CONTACT US</h2>
      <div class="tw-mt-10 tw-flex tw-flex-col tw-gap-y-4 lg:tw-mt-20">
        <div
          v-for="(branch, index) in branches"
          :key="`branch-${index}`"
          class="tw-grid tw-grid-cols-12 tw-gap-y-12 lg:tw-gap-x-12 xl:tw-gap-x-24"
        >
          <div class="tw-col-span-12 lg:tw-col-span-6">
            <nuxt-img :src="branch.photo" class="lg:tw-h-[416px] lg:tw-w-[650px]"></nuxt-img>
          </div>

          <div
            class="tw-col-span-12 tw-grid tw-grid-cols-12 tw-gap-x-6 tw-gap-y-8 lg:tw-col-span-6 lg:tw-gap-x-8 2xl:tw-gap-x-14"
          >
            <div v-if="branch.title" class="tw-col-span-12">
              <library-title tag="h2" :text="branch.title" class="tw-mb-2 lg:tw-mb-6" />
            </div>
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-4 lg:tw-col-span-6">
              <div v-if="branch.address" class="tw-pb-6" style="border-bottom: 1px solid var(--default-border-color)">
                <p>ADDRESS</p>
                <div style="width: 230px" class="tw-break-words">
                  <h6>{{ branch.address }}</h6>
                </div>
              </div>
              <div
                v-if="branch.primary_phone"
                class="tw-flex tw-flex-col tw-pb-6"
                style="border-bottom: 1px solid var(--default-border-color)"
              >
                <p>PHONE</p>
                <a
                  v-if="branch.primary_phone"
                  :href="`tel:${branch.primary_phone}`"
                  class="n-link tw-mt-2 tw-text-start"
                >
                  <h6>{{ branch.primary_phone }}</h6>
                </a>
                <a
                  v-if="branch.secondary_phone"
                  :href="`tel:${branch.secondary_phone}`"
                  class="n-link tw-mt-2 tw-text-start"
                >
                  <h6>{{ branch.secondary_phone }}</h6>
                </a>
              </div>
              <div
                v-if="branch.primary_email"
                class="tw-flex tw-flex-col tw-pb-6"
                style="border-bottom: 1px solid var(--default-border-color)"
              >
                <p>EMAIL</p>
                <a
                  v-if="branch.primary_email"
                  :href="`mailto:${branch.primary_email}`"
                  class="n-link tw-mt-2 tw-break-words tw-text-start"
                >
                  <h6>{{ branch.primary_email }}</h6>
                </a>
                <a
                  v-if="branch.secondary_email"
                  :href="`mailto:${branch.secondary_email}`"
                  class="n-link tw-mt-2 tw-break-words tw-text-start"
                >
                  <h6>{{ branch.secondary_email }}</h6>
                </a>
              </div>
              <div v-if="branch.primary_email" class="tw-flex tw-flex-col tw-pb-6">
                <p>SOCIALS</p>
                <div class="tw-mt-3 tw-flex tw-flex-row">
                  <a
                    v-if="branch.facebook"
                    :href="branch.facebook"
                    target="_blank"
                    class="n-link tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white"
                  >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#90C73D" />
                      <path
                        d="M19.3337 19.0007H21.0003L21.667 16.334H19.3337V15.0007C19.3337 14.314 19.3337 13.6673 20.667 13.6673H21.667V11.4273C21.4497 11.3987 20.629 11.334 19.7623 11.334C17.9523 11.334 16.667 12.4387 16.667 14.4673V16.334H14.667V19.0007H16.667V24.6673H19.3337V19.0007Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                  <a
                    v-if="branch.instagram"
                    :href="branch.instagram"
                    target="_blank"
                    class="n-link tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white"
                  >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#90C73D" />
                      <path
                        d="M15.1997 11.334H20.7997C22.933 11.334 24.6663 13.0673 24.6663 15.2007V20.8007C24.6663 21.8262 24.259 22.8097 23.5338 23.5348C22.8087 24.2599 21.8252 24.6673 20.7997 24.6673H15.1997C13.0663 24.6673 11.333 22.934 11.333 20.8007V15.2007C11.333 14.1751 11.7404 13.1916 12.4655 12.4665C13.1907 11.7414 14.1742 11.334 15.1997 11.334ZM15.0663 12.6673C14.4298 12.6673 13.8194 12.9202 13.3693 13.3703C12.9192 13.8203 12.6663 14.4308 12.6663 15.0673V20.934C12.6663 22.2606 13.7397 23.334 15.0663 23.334H20.933C21.5695 23.334 22.18 23.0811 22.6301 22.631C23.0802 22.181 23.333 21.5705 23.333 20.934V15.0673C23.333 13.7407 22.2597 12.6673 20.933 12.6673H15.0663ZM21.4997 13.6673C21.7207 13.6673 21.9326 13.7551 22.0889 13.9114C22.2452 14.0677 22.333 14.2796 22.333 14.5007C22.333 14.7217 22.2452 14.9336 22.0889 15.0899C21.9326 15.2462 21.7207 15.334 21.4997 15.334C21.2787 15.334 21.0667 15.2462 20.9104 15.0899C20.7541 14.9336 20.6663 14.7217 20.6663 14.5007C20.6663 14.2796 20.7541 14.0677 20.9104 13.9114C21.0667 13.7551 21.2787 13.6673 21.4997 13.6673ZM17.9997 14.6673C18.8837 14.6673 19.7316 15.0185 20.3567 15.6436C20.9818 16.2687 21.333 17.1166 21.333 18.0007C21.333 18.8847 20.9818 19.7326 20.3567 20.3577C19.7316 20.9828 18.8837 21.334 17.9997 21.334C17.1156 21.334 16.2678 20.9828 15.6427 20.3577C15.0175 19.7326 14.6663 18.8847 14.6663 18.0007C14.6663 17.1166 15.0175 16.2687 15.6427 15.6436C16.2678 15.0185 17.1156 14.6673 17.9997 14.6673ZM17.9997 16.0007C17.4692 16.0007 16.9605 16.2114 16.5855 16.5864C16.2104 16.9615 15.9997 17.4702 15.9997 18.0007C15.9997 18.5311 16.2104 19.0398 16.5855 19.4149C16.9605 19.7899 17.4692 20.0007 17.9997 20.0007C18.5301 20.0007 19.0388 19.7899 19.4139 19.4149C19.789 19.0398 19.9997 18.5311 19.9997 18.0007C19.9997 17.4702 19.789 16.9615 19.4139 16.5864C19.0388 16.2114 18.5301 16.0007 17.9997 16.0007Z"
                        fill="white"
                      />
                    </svg>
                  </a>

                  <a
                    v-if="branch.linkedin"
                    :href="branch.linkedin"
                    target="_blank"
                    class="n-link tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white"
                  >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#90C73D" />
                      <path
                        d="M14.6266 13.334C14.6265 13.6876 14.4858 14.0267 14.2356 14.2766C13.9855 14.5265 13.6462 14.6668 13.2926 14.6667C12.939 14.6665 12.5999 14.5258 12.35 14.2757C12.1001 14.0255 11.9598 13.6863 11.96 13.3327C11.9601 12.979 12.1008 12.64 12.351 12.3901C12.6011 12.1401 12.9403 11.9998 13.294 12C13.6476 12.0002 13.9867 12.1408 14.2366 12.391C14.4865 12.6412 14.6268 12.9804 14.6266 13.334ZM14.6666 15.654H12V24.0007H14.6666V15.654ZM18.88 15.654H16.2266V24.0007H18.8533V19.6207C18.8533 17.1807 22.0333 16.954 22.0333 19.6207V24.0007H24.6666V18.714C24.6666 14.6007 19.96 14.754 18.8533 16.774L18.88 15.654Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                  <a
                    v-if="branch.youtube"
                    :href="branch.youtube"
                    target="_blank"
                    class="n-link tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full tw-bg-white"
                  >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#90C73D" />
                      <g clip-path="url(#clip0_170_2521)">
                        <path
                          d="M17.9997 12.666C18.5697 12.666 19.1543 12.6807 19.721 12.7047L20.3903 12.7367L21.031 12.7747L21.631 12.8153L22.179 12.858C22.7737 12.9035 23.3333 13.1573 23.7594 13.5747C24.1854 13.9921 24.4506 14.5464 24.5083 15.14L24.535 15.4233L24.585 16.03C24.6317 16.6587 24.6663 17.344 24.6663 17.9993C24.6663 18.6547 24.6317 19.34 24.585 19.9687L24.535 20.5753C24.5263 20.6727 24.5177 20.7667 24.5083 20.8587C24.4506 21.4524 24.1853 22.0068 23.7591 22.4242C23.3329 22.8416 22.7732 23.0953 22.1783 23.1407L21.6317 23.1827L21.0317 23.224L20.3903 23.262L19.721 23.294C19.1476 23.3189 18.5737 23.3318 17.9997 23.3327C17.4257 23.3318 16.8518 23.3189 16.2783 23.294L15.609 23.262L14.9683 23.224L14.3683 23.1827L13.8203 23.1407C13.2256 23.0952 12.666 22.8414 12.24 22.424C11.8139 22.0066 11.5487 21.4523 11.491 20.8587L11.4643 20.5753L11.4143 19.9687C11.3634 19.3134 11.3362 18.6566 11.333 17.9993C11.333 17.344 11.3677 16.6587 11.4143 16.03L11.4643 15.4233C11.473 15.326 11.4817 15.232 11.491 15.14C11.5487 14.5465 11.8138 13.9923 12.2397 13.5749C12.6657 13.1575 13.2251 12.9037 13.8197 12.858L14.367 12.8153L14.967 12.7747L15.6083 12.7367L16.2777 12.7047C16.8513 12.6798 17.4255 12.6669 17.9997 12.666ZM17.9997 13.9993C17.4497 13.9993 16.8837 14.014 16.333 14.0367L15.681 14.068L15.055 14.1047L14.467 14.1447L13.9283 14.1867C13.6452 14.2068 13.3784 14.3264 13.1751 14.5245C12.9718 14.7226 12.8452 14.9862 12.8177 15.2687C12.7397 16.0747 12.6663 17.078 12.6663 17.9993C12.6663 18.9207 12.7397 19.924 12.8177 20.73C12.8743 21.3113 13.3357 21.7633 13.9283 21.812L14.467 21.8533L15.055 21.8933L15.681 21.9307L16.333 21.962C16.8837 21.9847 17.4497 21.9993 17.9997 21.9993C18.5497 21.9993 19.1157 21.9847 19.6663 21.962L20.3183 21.9307L20.9443 21.894L21.5323 21.854L22.071 21.812C22.3541 21.7919 22.621 21.6723 22.8243 21.4742C23.0276 21.2761 23.1542 21.0125 23.1817 20.73C23.2597 19.924 23.333 18.9207 23.333 17.9993C23.333 17.078 23.2597 16.0747 23.1817 15.2687C23.1542 14.9862 23.0276 14.7226 22.8243 14.5245C22.621 14.3264 22.3541 14.2068 22.071 14.1867L21.5323 14.1453L20.9443 14.1053L20.3183 14.068L19.6663 14.0367C19.1111 14.0128 18.5554 14.0003 17.9997 13.9993ZM16.6663 16.3827C16.6663 16.3175 16.6822 16.2533 16.7126 16.1957C16.743 16.1381 16.787 16.0888 16.8408 16.052C16.8947 16.0153 16.9566 15.9923 17.0214 15.985C17.0861 15.9776 17.1517 15.9862 17.2123 16.01L17.2663 16.0367L20.0663 17.6527C20.1221 17.6849 20.1693 17.73 20.2038 17.7843C20.2384 17.8386 20.2594 17.9004 20.2649 17.9646C20.2705 18.0287 20.2605 18.0932 20.2358 18.1527C20.2111 18.2121 20.1724 18.2647 20.123 18.306L20.0663 18.346L17.2663 19.9627C17.2099 19.9954 17.1464 20.0137 17.0812 20.0162C17.016 20.0187 16.9513 20.0053 16.8925 19.977C16.8338 19.9487 16.7828 19.9065 16.7441 19.8541C16.7053 19.8016 16.68 19.7405 16.6703 19.676L16.6663 19.616V16.3827Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_170_2521">
                          <rect width="16" height="16" fill="white" transform="translate(10 10)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-4 lg:tw-col-span-6">
              <p>OPENING HOURS</p>
              <div
                v-for="(officeHour, officeHourIndex) in branch.office_hours"
                :key="`${officeHour.title}-${index}-${officeHourIndex}`"
                class="tw-flex tw-flex-row tw-justify-between"
              >
                <div>{{ officeHour.title }}</div>
                <div>
                  {{ officeHour.value }}
                </div>
              </div>
              <div v-if="branch.general_office_hour" class="tw-mt-4">
                {{ branch.general_office_hour }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </library-container>

    <library-container v-if="variants.v3 === variant" class="tw-pb-24 tw-pt-48">
    <div>
      <h2>CONTACT US</h2>
      <div class="tw-mt-10 tw-flex tw-flex-col tw-gap-y-4 lg:tw-mt-20">
        <div
          v-for="(branch, index) in branches"
          :key="`branch-${index}`"
          class="tw-grid tw-grid-cols-12 tw-gap-y-12 lg:tw-gap-x-12 xl:tw-gap-x-24"
        >
          <div class="tw-col-span-12 lg:tw-col-span-6">
            <nuxt-img :src="branch.photo" class="lg:tw-h-[416px] lg:tw-w-[650px]"></nuxt-img>
          </div>

          <div
            class="tw-col-span-12 tw-grid tw-grid-cols-12 tw-gap-x-6 tw-gap-y-8 lg:tw-col-span-6 lg:tw-gap-x-8 2xl:tw-gap-x-14"
          >
            <div v-if="branch.title" class="tw-col-span-12">
              <library-title tag="h2" :text="branch.title" class="tw-mb-2 lg:tw-mb-6" />
            </div>
            <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-4 lg:tw-col-span-6">
              <div v-if="branch.address" class="tw-pb-6" style="border-bottom: 1px solid var(--default-border-color)">
                <h6>ADDRESS</h6>
                <div style="width: 230px" class="tw-break-words tw-mt-3">
                  <p>{{ branch.address }}</p>
                </div>
              </div>
              <div
                v-if="branch.primary_phone"
                class="tw-flex tw-flex-col tw-pb-6"
                style="border-bottom: 1px solid var(--default-border-color)"
              >
                <h6>PHONE</h6>
                <a
                  v-if="branch.primary_phone"
                  :href="`tel:${branch.primary_phone}`"
                  class="n-link tw-mt-3 tw-text-start"
                >
                  <p>{{ branch.primary_phone }}</p>
                </a>
                <a
                  v-if="branch.secondary_phone"
                  :href="`tel:${branch.secondary_phone}`"
                  class="n-link tw-mt-3 tw-text-start"
                >
                  <p>{{ branch.secondary_phone }}</p>
                </a>
              </div>
              <div
                v-if="branch.primary_email"
                class="tw-flex tw-flex-col tw-pb-6"
                style="border-bottom: 1px solid var(--default-border-color)"
              >
                <h6>EMAIL</h6>
                <a
                  v-if="branch.primary_email"
                  :href="`mailto:${branch.primary_email}`"
                  class="n-link tw-mt-2 tw-break-words tw-text-start"
                >
                  <h6>{{ branch.primary_email }}</h6>
                </a>
                <a
                  v-if="branch.secondary_email"
                  :href="`mailto:${branch.secondary_email}`"
                  class="n-link tw-mt-2 tw-break-words tw-text-start"
                >
                  <h6>{{ branch.secondary_email }}</h6>
                </a>
              </div>
              <div v-if="branch.primary_email" class="tw-flex tw-flex-col tw-pb-6">
                <h6>SOCIALS</h6>
                <div class="tw-mt-3 tw-flex tw-flex-row">
                  <a
                    v-if="branch.facebook"
                    :href="branch.facebook"
                    target="_blank"
                    class="n-link tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full "
                  >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="18" fill="#E7DFBA"/>
<path d="M19.3346 19H21.0013L21.668 16.3333H19.3346V15C19.3346 14.3133 19.3346 13.6666 20.668 13.6666H21.668V11.4266C21.4506 11.398 20.63 11.3333 19.7633 11.3333C17.9533 11.3333 16.668 12.438 16.668 14.4666V16.3333H14.668V19H16.668V24.6666H19.3346V19Z" fill="#1D1D1D"/>
</svg>

                  </a>
                  <a
                    v-if="branch.instagram"
                    :href="branch.instagram"
                    target="_blank"
                    class="n-link tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full "
                  >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#E7DFBA" />
                      <path
                        d="M15.1997 11.334H20.7997C22.933 11.334 24.6663 13.0673 24.6663 15.2007V20.8007C24.6663 21.8262 24.259 22.8097 23.5338 23.5348C22.8087 24.2599 21.8252 24.6673 20.7997 24.6673H15.1997C13.0663 24.6673 11.333 22.934 11.333 20.8007V15.2007C11.333 14.1751 11.7404 13.1916 12.4655 12.4665C13.1907 11.7414 14.1742 11.334 15.1997 11.334ZM15.0663 12.6673C14.4298 12.6673 13.8194 12.9202 13.3693 13.3703C12.9192 13.8203 12.6663 14.4308 12.6663 15.0673V20.934C12.6663 22.2606 13.7397 23.334 15.0663 23.334H20.933C21.5695 23.334 22.18 23.0811 22.6301 22.631C23.0802 22.181 23.333 21.5705 23.333 20.934V15.0673C23.333 13.7407 22.2597 12.6673 20.933 12.6673H15.0663ZM21.4997 13.6673C21.7207 13.6673 21.9326 13.7551 22.0889 13.9114C22.2452 14.0677 22.333 14.2796 22.333 14.5007C22.333 14.7217 22.2452 14.9336 22.0889 15.0899C21.9326 15.2462 21.7207 15.334 21.4997 15.334C21.2787 15.334 21.0667 15.2462 20.9104 15.0899C20.7541 14.9336 20.6663 14.7217 20.6663 14.5007C20.6663 14.2796 20.7541 14.0677 20.9104 13.9114C21.0667 13.7551 21.2787 13.6673 21.4997 13.6673ZM17.9997 14.6673C18.8837 14.6673 19.7316 15.0185 20.3567 15.6436C20.9818 16.2687 21.333 17.1166 21.333 18.0007C21.333 18.8847 20.9818 19.7326 20.3567 20.3577C19.7316 20.9828 18.8837 21.334 17.9997 21.334C17.1156 21.334 16.2678 20.9828 15.6427 20.3577C15.0175 19.7326 14.6663 18.8847 14.6663 18.0007C14.6663 17.1166 15.0175 16.2687 15.6427 15.6436C16.2678 15.0185 17.1156 14.6673 17.9997 14.6673ZM17.9997 16.0007C17.4692 16.0007 16.9605 16.2114 16.5855 16.5864C16.2104 16.9615 15.9997 17.4702 15.9997 18.0007C15.9997 18.5311 16.2104 19.0398 16.5855 19.4149C16.9605 19.7899 17.4692 20.0007 17.9997 20.0007C18.5301 20.0007 19.0388 19.7899 19.4139 19.4149C19.789 19.0398 19.9997 18.5311 19.9997 18.0007C19.9997 17.4702 19.789 16.9615 19.4139 16.5864C19.0388 16.2114 18.5301 16.0007 17.9997 16.0007Z"
                        fill="#1D1D1D"
                      />
                    </svg>
                  </a>

                  <a
                    v-if="branch.linkedin"
                    :href="branch.linkedin"
                    target="_blank"
                    class="n-link tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full"
                  >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#E7DFBA" />
                      <path
                        d="M14.6266 13.334C14.6265 13.6876 14.4858 14.0267 14.2356 14.2766C13.9855 14.5265 13.6462 14.6668 13.2926 14.6667C12.939 14.6665 12.5999 14.5258 12.35 14.2757C12.1001 14.0255 11.9598 13.6863 11.96 13.3327C11.9601 12.979 12.1008 12.64 12.351 12.3901C12.6011 12.1401 12.9403 11.9998 13.294 12C13.6476 12.0002 13.9867 12.1408 14.2366 12.391C14.4865 12.6412 14.6268 12.9804 14.6266 13.334ZM14.6666 15.654H12V24.0007H14.6666V15.654ZM18.88 15.654H16.2266V24.0007H18.8533V19.6207C18.8533 17.1807 22.0333 16.954 22.0333 19.6207V24.0007H24.6666V18.714C24.6666 14.6007 19.96 14.754 18.8533 16.774L18.88 15.654Z"
                        fill="#1D1D1D"
                      />
                    </svg>
                  </a>
                  <a
                    v-if="branch.youtube"
                    :href="branch.youtube"
                    target="_blank"
                    class="n-link tw-mr-3 tw-flex tw-h-9 tw-w-9 tw-flex-shrink tw-items-center tw-justify-center tw-rounded-full"
                  >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="18" r="18" fill="#E7DFBA" />
                      <g clip-path="url(#clip0_170_2521)">
                        <path
                          d="M17.9997 12.666C18.5697 12.666 19.1543 12.6807 19.721 12.7047L20.3903 12.7367L21.031 12.7747L21.631 12.8153L22.179 12.858C22.7737 12.9035 23.3333 13.1573 23.7594 13.5747C24.1854 13.9921 24.4506 14.5464 24.5083 15.14L24.535 15.4233L24.585 16.03C24.6317 16.6587 24.6663 17.344 24.6663 17.9993C24.6663 18.6547 24.6317 19.34 24.585 19.9687L24.535 20.5753C24.5263 20.6727 24.5177 20.7667 24.5083 20.8587C24.4506 21.4524 24.1853 22.0068 23.7591 22.4242C23.3329 22.8416 22.7732 23.0953 22.1783 23.1407L21.6317 23.1827L21.0317 23.224L20.3903 23.262L19.721 23.294C19.1476 23.3189 18.5737 23.3318 17.9997 23.3327C17.4257 23.3318 16.8518 23.3189 16.2783 23.294L15.609 23.262L14.9683 23.224L14.3683 23.1827L13.8203 23.1407C13.2256 23.0952 12.666 22.8414 12.24 22.424C11.8139 22.0066 11.5487 21.4523 11.491 20.8587L11.4643 20.5753L11.4143 19.9687C11.3634 19.3134 11.3362 18.6566 11.333 17.9993C11.333 17.344 11.3677 16.6587 11.4143 16.03L11.4643 15.4233C11.473 15.326 11.4817 15.232 11.491 15.14C11.5487 14.5465 11.8138 13.9923 12.2397 13.5749C12.6657 13.1575 13.2251 12.9037 13.8197 12.858L14.367 12.8153L14.967 12.7747L15.6083 12.7367L16.2777 12.7047C16.8513 12.6798 17.4255 12.6669 17.9997 12.666ZM17.9997 13.9993C17.4497 13.9993 16.8837 14.014 16.333 14.0367L15.681 14.068L15.055 14.1047L14.467 14.1447L13.9283 14.1867C13.6452 14.2068 13.3784 14.3264 13.1751 14.5245C12.9718 14.7226 12.8452 14.9862 12.8177 15.2687C12.7397 16.0747 12.6663 17.078 12.6663 17.9993C12.6663 18.9207 12.7397 19.924 12.8177 20.73C12.8743 21.3113 13.3357 21.7633 13.9283 21.812L14.467 21.8533L15.055 21.8933L15.681 21.9307L16.333 21.962C16.8837 21.9847 17.4497 21.9993 17.9997 21.9993C18.5497 21.9993 19.1157 21.9847 19.6663 21.962L20.3183 21.9307L20.9443 21.894L21.5323 21.854L22.071 21.812C22.3541 21.7919 22.621 21.6723 22.8243 21.4742C23.0276 21.2761 23.1542 21.0125 23.1817 20.73C23.2597 19.924 23.333 18.9207 23.333 17.9993C23.333 17.078 23.2597 16.0747 23.1817 15.2687C23.1542 14.9862 23.0276 14.7226 22.8243 14.5245C22.621 14.3264 22.3541 14.2068 22.071 14.1867L21.5323 14.1453L20.9443 14.1053L20.3183 14.068L19.6663 14.0367C19.1111 14.0128 18.5554 14.0003 17.9997 13.9993ZM16.6663 16.3827C16.6663 16.3175 16.6822 16.2533 16.7126 16.1957C16.743 16.1381 16.787 16.0888 16.8408 16.052C16.8947 16.0153 16.9566 15.9923 17.0214 15.985C17.0861 15.9776 17.1517 15.9862 17.2123 16.01L17.2663 16.0367L20.0663 17.6527C20.1221 17.6849 20.1693 17.73 20.2038 17.7843C20.2384 17.8386 20.2594 17.9004 20.2649 17.9646C20.2705 18.0287 20.2605 18.0932 20.2358 18.1527C20.2111 18.2121 20.1724 18.2647 20.123 18.306L20.0663 18.346L17.2663 19.9627C17.2099 19.9954 17.1464 20.0137 17.0812 20.0162C17.016 20.0187 16.9513 20.0053 16.8925 19.977C16.8338 19.9487 16.7828 19.9065 16.7441 19.8541C16.7053 19.8016 16.68 19.7405 16.6703 19.676L16.6663 19.616V16.3827Z"
                          fill="#1D1D1D"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_170_2521">
                          <rect width="16" height="16" fill="white" transform="translate(10 10)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="tw-col-span-12 tw-flex tw-text-white tw-flex-col tw-gap-y-4 lg:tw-col-span-6">
              <h6>OPENING HOURS</h6>
              <div
                v-for="(officeHour, officeHourIndex) in branch.office_hours"
                :key="`${officeHour.title}-${index}-${officeHourIndex}`"
                class="tw-flex tw-flex-row tw-justify-between"
              >
                <div>{{ officeHour.title }}</div>
                <div>
                  {{ officeHour.value }}
                </div>
              </div>
              <div v-if="branch.general_office_hour" class="tw-mt-4">
                {{ branch.general_office_hour }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </library-container>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme3Branches',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
    };
  },

  computed: {
    branches() {
      const branches = this.groupedVariables.branches;
      if (branches && branches.length) {
        return branches.map((branch) => {
          return {
            ...branch,
            office_hours: [
              {
                title: 'Monday',
                value: branch.monday,
              },
              {
                title: 'Tuesday',
                value: branch.tuesday,
              },
              {
                title: 'Wednesday',
                value: branch.wednesday,
              },
              {
                title: 'Thursday',
                value: branch.thursday,
              },
              {
                title: 'Friday',
                value: branch.friday,
              },
              {
                title: 'Saturday',
                value: branch.saturday,
              },
              {
                title: 'Sunday',
                value: branch.sunday,
              },
            ],
          };
        });
      }
      return [];
    },

    title() {
      return this.vars.titleText;
    },
  },
});
</script>
